<template>
  <section id="contacto" class="contactform">
        <Form
          :item="userContact"
          buttonText="Enviar"
          :formTitle="contactTexts.title"
          :textHelp="contactTexts.subtitle"
        />
        <Message
          :showmsg="isSuccess"
          type="success absolute"
          :showClose="false"
          @clicMsg="closeMsg()"
          >{{ messageResponse }}
        </Message>
      </section>
</template>

<script>
import Form from "@/components/molecules/ContactForm.vue";
import Message from "@/components/atoms/Message.vue";
import newTexts from "@/data/newTexts"

export default {
  name: "Contact",
  components: {
    Form, 
    Message
  },
  data(){
   return {
    contactTexts: newTexts.contactSection,
    userContact: {
        subject: "",
        username: "",
        email: "",
        phone: "",
        message: "",
      },
   }
  },
  computed: {

    isSuccess() {
      const SUCCESS = this.$store.state.emailResponse.isSuccess;
      return SUCCESS;
    },
    messageResponse() {
      return this.$store.state.emailResponse.message;
    },
  },
}


</script>